export const emptyProfile = {
  id: '',
  name: '',
  lastName: '',
  role: '',
  core_skill: '',
  grade: '',
  DU: '',
  email: '',
  summary: '',
  since: '',
  programming_languages: [],
  databases: [],
  technologies_and_frameworks: [],
  soft_skills: [],
  hobbies: [],
  educational_background: [],
  certification: [],
  languages: [],
  professional_experience: [],
  domains: [],
  profile_image: undefined,
  uploaded_image: undefined,
  technical_skills: [],
  profile_filling_percentage: 0,
  repository: {
    linkedin_link: '',
    github_link: ''
  }
}
